export default __webpack_public_path__ + "static/media/lenima.340aa540.jpeg";